<template>
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper" @click.self="$emit('close')">
            <div class="modal-container">
    
              <div class="modal-header">
                <slot name="header">
                  default header
                </slot>
              </div>
    
              <div class="modal-body">
                <slot name="body">
                  default body
                </slot>
              </div>
    
              <div class="modal-footer">
                <slot name="footer">
                  <button class="modal-default-button  green" @click="$emit('close')">
                    ✓ {{ $t('button.done') }}
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
    </transition>
</template>

<script>

export default {

    name: 'Modal',
    components: {
    },
    data : function(){
        return {
            showModal: false
        }
    },
    props: {

    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    test-align: left;
    display: table-cell;
    vertical-align: middle;
}
.modal-container * {
    text-align: left;
}

.modal-container {
  max-width: 860px;
  min-width: 420px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #ddd;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

div.clear {
    clear: both;
}

div.col {
    float: left;
    margin-right: 30px;
    width: 400px;
}

hr {
    background: 1px solid #fff;
}
</style>
